import { View, Text } from "react-native";
import React, { useEffect } from "react";
import { createStackNavigator } from "@react-navigation/stack";

import TestStartInfo from "./TestStartInfo";
import TestQuestion from "./TestQuestion";
import AnswerReview from "./AnswerReview";
import TestReview from "./TestReview";

const Stack = createStackNavigator();

export default function DoTestNavigator() {
  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false, animationEnabled: true }}
      initialRouteName="TestStartInfo"
    >
      <Stack.Screen name="TestStartInfo" component={TestStartInfo} />
      <Stack.Screen
        name="TestQuestion"
        component={TestQuestion}
        initialParams={{ questionNumber: 1 }}
      />
      <Stack.Screen name="AnswerReview" component={AnswerReview} />
      <Stack.Screen name="TestReview" component={TestReview} />
    </Stack.Navigator>
  );
}
